module.exports = __webpack_public_path__ + "img/logo.7dce15f0.svg";